
export default function MobileCallButton() {
  return (
    <a
      href="tel:717-280-2005"
      className="fixed bottom-20 right-4 z-40 md:hidden flex items-center gap-2 bg-neon-green text-matte-black px-5 py-3 rounded-full shadow-lg hover:bg-white transition-all duration-300 cursor-pointer"
      aria-label="Call IronCore Roofing"
    >
      <div className="w-5 h-5 flex items-center justify-center">
        <i className="ri-phone-fill text-lg"></i>
      </div>
      <span className="font-bold text-sm whitespace-nowrap">Call Now</span>
    </a>
  );
}
